module.exports = __webpack_public_path__ + "img/Picture22.9b6d7a28.png";